<div *ngIf="showPricing" style="position: relative; min-height: 100px;">
  <div class="d-flex align-items-center">
    <div class="l2-title">
      Repair Plan
    </div>
  </div>
  <ng-container *ngIf="!isDetail">
    <div class="item-repair-plan mb-8px">
    <span>
      <p>Using the information provided on the previous steps, we have estimated the repair and costs necessary to your Samsung product.</p>
    The repair plan will be sent to customer via SMS and Email.<br>
    The customer must input credit card information using attached URL in 5 days.
    </span>
    </div>
    <div class="item-pricing mb-2px">
      <div class="item-label">Standard Repair</div>
      <div class="item-value-pricing">{{ pricing?.pricing?.parts?.price | currency }}</div>
    </div>
    <div class="item-pricing mb-2px">
      <div class="item-label">Tax</div>
      <div class="item-value-pricing">{{ pricing?.pricing?.parts?.tax | currency }}</div>
    </div>
    <div class="dot-horizontal-line"></div>
  </ng-container>
  <div class="item-pricing mb-2px">
    <div class="item-label">Total</div>
    <div class="item-value-pricing pricing-total">{{ pricing?.amount | currency }}</div>
  </div>
  <div *ngIf="pricing?.amount > 0" class="d-flex">
    <div class="item-label">Credit Card Holding</div>
    <dp-badge [color]="color.cardStatus" [size]="'wd-fit'" [text]="pricing?.status ? 'YES' : 'NO'"></dp-badge>
  </div>
  <ngx-spinner [fullScreen]="false" bdColor="rgba(255,255,255,0.8)" color="#000000" name="pricing" size="default"
               type="line-spin-clockwise-fade"></ngx-spinner>
</div>
<div class="ticket-horizontal-line"></div>
